import { View } from 'react-native';
import { clamp } from '../lib/utils';

interface ProgressBarProps {
  /** 0–1 */
  value: number;
  /** Tailwind color class for the filled bar. Default: bg-forest-500 */
  color?: string;
  height?: number;
  /** Optional vertical line position (0–1). */
  marker?: number;
  /** Width of the marker line. Default: 2 */
  markerWidth?: number;
}

export function ProgressBar({
  value,
  color = 'bg-forest-500',
  height = 8,
  marker,
  markerWidth = 2
}: ProgressBarProps) {
  const pct = `${clamp(value, 0, 1) * 100}%` as `${number}%`;
  const markerPos = marker != null ? `${clamp(marker, 0, 1) * 100}%` as `${number}%` : null;

  return (
    <View className="w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden relative" style={{ height }}>
      {/* Background bar */}
      <View className={`${color} rounded-full`} style={{ width: pct, height }} />
      
      {/* Optional progress marker (vertical line) */}
      {markerPos && (
        <View 
          className="absolute top-0 bottom-0 bg-gray-900 dark:bg-gray-100 z-10" 
          style={{ left: markerPos, width: markerWidth }}
        />
      )}
    </View>
  );
}
